import React from 'react';
import { Link } from 'react-router-dom';
import './ForBusinessesPage.css';

function ForBusinessesPage() {
  return (
    <div className="for-businesses-page">
      {/* Hero Section */}
      <section className="b2b-hero">
        <div className="b2b-hero-content">
          <div className="hero-badge">For Pet Care Businesses</div>
          <h1>Turn Every Visit Into A Lasting Memory</h1>
          <p className="hero-subtitle">
            Give your customers magical video memories of their pets. BarkBacks helps daycare, grooming,
            and boarding businesses create deeper connections and boost revenue.
          </p>
          <div className="hero-buttons">
            <Link to="/business/register" className="btn btn-primary btn-large">Start Free Trial</Link>
            <Link to="/business/login" className="btn btn-secondary btn-large">Business Login</Link>
          </div>
          <div className="trust-badge">
            Join 500+ pet care businesses using BarkBacks
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <h2>Why Pet Care Businesses Love BarkBacks</h2>
        <div className="benefits-grid">
          <div className="benefit-card">
            <div className="benefit-icon">💰</div>
            <h3>Increase Revenue</h3>
            <p>Average businesses see $500-2000/month in additional revenue from video packages</p>
          </div>
          <div className="benefit-card">
            <div className="benefit-icon">❤️</div>
            <h3>Build Loyalty</h3>
            <p>Create emotional connections that turn one-time visitors into lifetime customers</p>
          </div>
          <div className="benefit-card">
            <div className="benefit-icon">📱</div>
            <h3>Easy to Use</h3>
            <p>Staff can create videos in under 2 minutes. No technical skills required</p>
          </div>
          <div className="benefit-card">
            <div className="benefit-icon">📊</div>
            <h3>Track Performance</h3>
            <p>Comprehensive dashboard showing revenue, customer engagement, and video analytics</p>
          </div>
        </div>
      </section>

      {/* How It Works For Businesses */}
      <section className="b2b-how-it-works">
        <h2>How It Works For Your Business</h2>
        <div className="b2b-steps">
          <div className="b2b-step">
            <div className="step-number">1</div>
            <h3>Set Up Your Portal</h3>
            <p>Get a branded landing page where customers can purchase video packages</p>
          </div>
          <div className="b2b-step">
            <div className="step-number">2</div>
            <h3>Capture Moments</h3>
            <p>Staff snaps photos during daycare, grooming, or boarding visits</p>
          </div>
          <div className="b2b-step">
            <div className="step-number">3</div>
            <h3>Generate Videos</h3>
            <p>Create AI-powered video stories in minutes with our simple interface</p>
          </div>
          <div className="b2b-step">
            <div className="step-number">4</div>
            <h3>Delight Customers</h3>
            <p>Customers receive magical videos they can share with friends and family</p>
          </div>
        </div>
      </section>

      {/* Pricing Tiers */}
      <section className="b2b-pricing">
        <h2>Simple, Transparent Pricing</h2>
        <p className="pricing-subtitle">Start free, upgrade as you grow</p>
        <div className="pricing-grid">
          <div className="pricing-card">
            <div className="pricing-header">
              <h3>Free</h3>
              <div className="price">$0<span>/month</span></div>
            </div>
            <ul className="pricing-features">
              <li>✓ 10 videos per month</li>
              <li>✓ Basic analytics</li>
              <li>✓ Branded customer portal</li>
              <li>✓ Standard support</li>
            </ul>
            <Link to="/business/register" className="btn btn-outline">Get Started</Link>
          </div>

          <div className="pricing-card featured">
            <div className="popular-badge">Most Popular</div>
            <div className="pricing-header">
              <h3>Starter</h3>
              <div className="price">$49<span>/month</span></div>
            </div>
            <ul className="pricing-features">
              <li>✓ 50 videos per month</li>
              <li>✓ Advanced analytics</li>
              <li>✓ Custom branding</li>
              <li>✓ Priority support</li>
              <li>✓ Revenue tracking</li>
            </ul>
            <Link to="/business/register" className="btn btn-primary">Start Free Trial</Link>
          </div>

          <div className="pricing-card">
            <div className="pricing-header">
              <h3>Professional</h3>
              <div className="price">$149<span>/month</span></div>
            </div>
            <ul className="pricing-features">
              <li>✓ Unlimited videos</li>
              <li>✓ Full analytics suite</li>
              <li>✓ White-label solution</li>
              <li>✓ Dedicated support</li>
              <li>✓ API access</li>
              <li>✓ Custom integrations</li>
            </ul>
            <Link to="/business/register" className="btn btn-outline">Contact Sales</Link>
          </div>
        </div>
      </section>

      {/* Perfect For Section */}
      <section className="perfect-for">
        <h2>Perfect For</h2>
        <div className="business-types">
          <div className="business-type">
            <div className="business-icon">🏠</div>
            <h3>Dog Daycare</h3>
            <p>Share daily highlights with pet parents</p>
          </div>
          <div className="business-type">
            <div className="business-icon">✂️</div>
            <h3>Pet Grooming</h3>
            <p>Showcase transformation videos</p>
          </div>
          <div className="business-type">
            <div className="business-icon">🏨</div>
            <h3>Pet Boarding</h3>
            <p>Keep owners connected while away</p>
          </div>
          <div className="business-type">
            <div className="business-icon">🏥</div>
            <h3>Veterinary Clinics</h3>
            <p>Share positive visit experiences</p>
          </div>
          <div className="business-type">
            <div className="business-icon">🎓</div>
            <h3>Training Schools</h3>
            <p>Document progress and milestones</p>
          </div>
          <div className="business-type">
            <div className="business-icon">📸</div>
            <h3>Pet Photography</h3>
            <p>Add video services to your offerings</p>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="b2b-cta">
        <h2>Ready to Transform Your Pet Care Business?</h2>
        <p>Start creating magical memories for your customers today</p>
        <div className="cta-buttons">
          <Link to="/business/register" className="btn btn-primary btn-large">Start Free Trial</Link>
          <a href="mailto:business@barkbacks.com" className="btn btn-secondary btn-large">Contact Sales</a>
        </div>
        <p className="cta-note">No credit card required • Cancel anytime • 14-day free trial</p>
      </section>
    </div>
  );
}

export default ForBusinessesPage;
